import { RecordOf } from '@opengov/compose-app/immutable';

export enum EReportActionSet {
  ReportOwner = 'ReportOwner',
  ReportEditor = 'ReportEditor',
  ReportViewer = 'ReportViewer',
  ReportSavedViewEditor = 'ReportSavedViewEditor',
  ReportNoAccess = 'none'
}

export interface IResourceGrant {
  id?: string; //it is required in response, but not required in payload
  granteeId: string;
  granteeType: string;
  resourceId: string;
  actionSet: EReportActionSet;
}

export const ResourceGrant = RecordOf<IResourceGrant>({
  id: null,
  granteeId: null,
  granteeType: null,
  resourceId: null,
  actionSet: null
});

export interface IResourceGrantLifeCycledata {
  createdBy: number;
  updatedBy: number;
  createdAt: string;
  updatedAt: string;
}

export type IResourceGrantPayload = IResourceGrant;
export type IResourceGrantResponse = IResourceGrant & IResourceGrantLifeCycledata;

export enum EGranteeType {
  User = 'user',
  Group = 'group'
}

export interface IGrantee {
  // Primary key of the underlying resource_grant row, when present.
  // This is generated in the DB and is optional in payloads.
  id?: string;
  granteeId: string;
  granteeName: string;
  granteeEmail: string;
  granteeType: EGranteeType;
  actionSet?: string;
}

export interface IInvitableUser {
  granteeId: string;
  granteeName: string;
  granteeEmail: string;
}
